export default __webpack_public_path__ + "56cf6a53ea00ea83d8932e20f767ae2d.png";